export function dashCase(input: string): string {
  return (input || '').toLowerCase().replace(/\s+/g, '-');
}

export function parseArrayFromString(value: string): string[] {
  if (!value || value === '[]') {
    return [];
  }

  return value.startsWith('[') && value.endsWith(']')
    ? value
        .slice(1, -1)
        .split(',')
        .map((s) => s.trim())
    : [value.toString()];
}

export function alphabeticalSort(a, b) {
  return a.localeCompare(b);
}

export function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function getArraysIntersection(arrays: string[][]): string[] {
  let intersection = [];
  if (arrays.length === 1) {
    intersection = arrays[0];
  } else if (arrays.length > 1) {
    intersection = arrays.reduce((a, b) => a.filter((f) => b.includes(f)));
  }
  return intersection;
}

export function arraysEqual(a: string[], b: string[]) {
  a = Array.isArray(a) ? a : [];
  b = Array.isArray(b) ? b : [];
  return a.length === b.length && a.every((el, ix) => el === b[ix]);
}

export function capitalizeFirstLetter(value: string) {
  if (!value) return '';

  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatList(list: string[]) {
  if (list.length === 1) {
    return list[0];
  }

  return list.slice(0, -1).join(', ') + ' and ' + list.slice(-1)[0];
}
